

export const namespace = /* INJECT */ {__namespace__:true};
export const classes = /* INJECT */ {__classes__:true};
export const keyframes = /* INJECT */ {__keyframes__:true}; 
export const stVars = /* INJECT */ {__stVars__:true}; 
export const vars = /* INJECT */ {__vars__:true}; 
export const cssStates = /* INJECT */ {__stc__:true};
export const style = /* INJECT */ {__sts__:true};
export const st = /* INJECT */ {__st__:true};
/* JS_INJECT */
if(import.meta.webpackHot /* HMR */) { import.meta.webpackHot.accept();}
